import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { secureFetch } from "../data/secureFetch";
import "./SystemAdminDashboard.css";

/**
 * System Admin Organizations List
 * Read-only view of all organizations
 */
function SystemAdminOrganizations() {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const fetchOrganizations = useCallback(async () => {
    try {
      setLoading(true);
      const path = `/api/system-admin/organizations?search=${encodeURIComponent(
        search
      )}&limit=50`;

      const response = await secureFetch(path, { method: "GET" });

      if (!response.ok) {
        throw new Error("Failed to fetch organizations");
      }

      setOrganizations(response.organizations);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching organizations:", err);
      setError(err.message);
      setLoading(false);
    }
  }, [search]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchOrganizations();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [fetchOrganizations]);

  const handleViewOrg = (orgId) => {
    navigate(`/system-admin/organizations/${orgId}`);
  };

  return (
    <div className="system-admin-page">
      <div className="page-header">
        <h1>System Admin Dashboard</h1>
        <p className="page-subtitle">Read-only view of all organizations</p>
      </div>

      <div className="search-section">
        <input
          type="text"
          className="search-input"
          placeholder="Search by name, EIN, or organization ID..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button onClick={fetchOrganizations} className="btn-search">
          Search
        </button>
      </div>

      {loading && <div className="loading">Loading organizations...</div>}
      {error && <div className="error-message">Error: {error}</div>}

      {!loading && !error && (
        <div className="org-table-container">
          <table className="org-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>EIN</th>
                <th>Email</th>
                <th>Verified</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {organizations.map((org) => (
                <tr key={org.id}>
                  <td>{org.id}</td>
                  <td className="org-name">{org.name}</td>
                  <td>{org.ein || "N/A"}</td>
                  <td>{org.email || "N/A"}</td>
                  <td>{org.verified ? "Yes" : "No"}</td>
                  <td>
                    <button
                      onClick={() => handleViewOrg(org.id)}
                      className="btn-view"
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {organizations.length === 0 && (
            <div className="no-results">No organizations found</div>
          )}
        </div>
      )}
    </div>
  );
}

export default SystemAdminOrganizations;
